import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { Box, Button, Center, Flex, Grid, Spinner, Text, VStack, } from "@chakra-ui/react";
import { useApplicableOffers } from "../../hooks/useApplicableOffers";
import { IN_HOUSE_OFFER_SECTIONS, groupOffersBySection, } from "../../types/applicableOffer";
import InHouseOfferRowCard from "./InHouseOfferRowCard";
import InHouseOfferPreviewCard from "./InHouseOfferPreviewCard";
import InHouseOfferDetailsSheet from "./InHouseOfferDetailsSheet";
import InHouseOffersEmptyState from "./InHouseOffersEmptyState";
const InHouseOffersListView = ({ eventId, reservationTime, mode, initialSelectedCodes = [], onConfirm, }) => {
    const { data, isLoading, isError } = useApplicableOffers({
        eventId,
        reservationTime,
    });
    const offers = data !== null && data !== void 0 ? data : [];
    const grouped = useMemo(() => groupOffersBySection(offers), [offers]);
    const [selectedCodes, setSelectedCodes] = useState(() => new Set(initialSelectedCodes));
    const [detailsOffer, setDetailsOffer] = useState(null);
    const toggleSelect = (offer) => {
        setSelectedCodes((prev) => {
            const next = new Set(prev);
            if (next.has(offer.code)) {
                next.delete(offer.code);
            }
            else {
                next.add(offer.code);
            }
            return next;
        });
    };
    const isOfferDisabled = (offer) => {
        if (mode !== "cart")
            return false;
        if (selectedCodes.has(offer.code))
            return false;
        if (selectedCodes.size === 0)
            return false;
        if (offer.can_be_clubbed === false)
            return true;
        return offers.some((o) => selectedCodes.has(o.code) && o.can_be_clubbed === false);
    };
    const selectedOffers = useMemo(() => offers.filter((o) => selectedCodes.has(o.code)), [offers, selectedCodes]);
    const totalSelectedAmount = useMemo(() => selectedOffers.reduce((sum, o) => sum + (o.discounted_price || 0), 0), [selectedOffers]);
    if (isLoading) {
        return (_jsx(Center, { py: 20, children: _jsx(Spinner, { color: "#8155FE" }) }));
    }
    if (isError || offers.length === 0) {
        return (_jsx(Box, { px: 4, py: 6, children: _jsx(InHouseOffersEmptyState, {}) }));
    }
    return (_jsxs(Box, { pt: 6, pb: mode === "cart" ? "120px" : "48px", children: [_jsx(VStack, { align: "stretch", spacing: 6, px: 4, children: IN_HOUSE_OFFER_SECTIONS.map((section) => {
                    const sectionOffers = grouped[section.key];
                    if (sectionOffers.length === 0)
                        return null;
                    return (_jsxs(Box, { children: [_jsx(Text, { fontSize: "md", fontWeight: 800, color: "white", textTransform: "uppercase", letterSpacing: "0.05em", mb: 1, children: section.label }), section.subtitle && (_jsx(Text, { fontSize: "xs", color: "rgba(255,255,255,0.5)", mb: 3, children: section.subtitle })), _jsx(Grid, { templateColumns: ["1fr", "1fr", "1fr", "repeat(2, 1fr)"], gap: 4, children: sectionOffers.map((offer) => (_jsx(Box, { gridColumn: sectionOffers.length === 1
                                        ? { base: "auto", lg: "1 / -1" }
                                        : undefined, children: mode === "view" ? (_jsx(InHouseOfferPreviewCard, { offer: offer, onDetailsClick: (o) => setDetailsOffer(o) })) : (_jsx(InHouseOfferRowCard, { offer: offer, mode: mode, selected: selectedCodes.has(offer.code), disabled: isOfferDisabled(offer), onAction: () => toggleSelect(offer), onDetailsClick: (o) => setDetailsOffer(o) })) }, offer.id))) })] }, section.key));
                }) }), mode === "cart" && (_jsx(Box, { position: "fixed", bottom: 0, left: 0, right: 0, bg: "#0F0F0F", borderTop: "1px solid #2A2A2A", px: 4, py: 3, zIndex: 20, children: _jsxs(Flex, { maxW: "1100px", mx: "auto", align: "center", justify: "space-between", gap: 4, children: [_jsxs(Box, { children: [totalSelectedAmount > 0 && (_jsxs(Text, { fontSize: "md", fontWeight: 700, color: "white", children: ["\u20B9", totalSelectedAmount.toLocaleString("en-IN")] })), _jsxs(Text, { fontSize: "11px", color: "rgba(255,255,255,0.6)", children: [_jsx(Text, { as: "span", color: "#8155FE", children: "\u2726" }), " ", selectedOffers.length, " Offer", selectedOffers.length === 1 ? "" : "s", " Applied"] })] }), _jsx(Button, { bg: "#8155FE", color: "white", borderRadius: "10px", h: "44px", px: 6, fontSize: "sm", fontWeight: 600, _hover: { bg: "#9166FF" }, isDisabled: selectedOffers.length === 0, _disabled: {
                                bg: "#3B2F66",
                                color: "rgba(255,255,255,0.55)",
                                cursor: "not-allowed",
                                _hover: { bg: "#3B2F66" },
                            }, onClick: () => onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(selectedOffers), children: "Apply" })] }) })), _jsx(InHouseOfferDetailsSheet, { isOpen: !!detailsOffer, onClose: () => setDetailsOffer(null), offer: detailsOffer })] }));
};
export default InHouseOffersListView;
